import { getQuoteResolver } from "../../../quote/shared/resolvers/get-quote.resolver";
import { startPagePath } from "../quote/term-life-insurance/quote-route.constant";
import { CustomRoute, Page, Type } from "../shared/shared-route.constant";

export const rootRoutes: CustomRoute[] = [
  {
    path: Page.CONTINUE,
    loadComponent: () =>
      import("../../pages/continue/continue.page").then((m) => m.ContinuePage),
    data: {
      page: Page.CONTINUE,
      type: Type.PRODUCT_AGNOSTIC,
      htmlTitle: $localize`Weiter`,
    },
    resolve: {
      quote: getQuoteResolver,
    },
  },
  {
    path: Page.DEFAULT,
    redirectTo: startPagePath,
    pathMatch: "full",
    data: {
      type: Type.PRODUCT_AGNOSTIC,
      page: Page.DEFAULT,
      htmlTitle: "IsNotNeededDueToRedirect",
    },
  },
];

export const topLevelRoutes: CustomRoute[] = [...rootRoutes];
